//* Config imports
import { API_URL, getAuthHeaders } from "@/config/api";

export function useGetPhaseForms() {
  const getPhaseForms = async () => {
    const response = await fetch(`${API_URL}/phaseforms`, {
      headers: getAuthHeaders(),
    });
    return response.json();
  };

  return { getPhaseForms };
}
